export default "__VITE_PUBLIC_ASSET__f1a688c0__"